import { render, staticRenderFns } from "./KeyValues.vue?vue&type=template&id=58b4e9e0&scoped=true&"
import script from "./KeyValues.vue?vue&type=script&lang=js&"
export * from "./KeyValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4e9e0",
  null
  
)

export default component.exports